import apiClient from "../../../helpers/apiClient";
import { RESERVATION_TAB_KEYS } from "./reservationTabConfig";

const FETCH_ALL_LIMIT = "100000";

const bySerialDesc = (a, b) => (b.serialID ?? 0) - (a.serialID ?? 0);

const fetchAllReservationsCombined = async () => {
    const queryParams = new URLSearchParams({ limit: FETCH_ALL_LIMIT, page: "1" });

    const [presentReservations, pastReservation] = await Promise.all([
        apiClient.get(`/api/reservation/list?${queryParams}`),
        apiClient.get(`/api/past-reservation/list?${queryParams}`),
    ]);

    if (presentReservations?.data?.success && pastReservation?.data?.success) {
        const combinedData = [
            ...(presentReservations?.data?.data?.result || []),
            ...(pastReservation?.data?.data?.result || []),
        ];
        return combinedData.sort(bySerialDesc);
    }

    return [];
};

const getTabRequest = (tabKey, upcomingFilter) => {
    const params = {};
    let endpoint = "/api/reservation/list";

    switch (tabKey) {
        case RESERVATION_TAB_KEYS.UPCOMING:
            params.isCarPickedUp = "false";
            if (upcomingFilter === "car_needed") params.carSelected = "false";
            if (upcomingFilter === "car_assigned") params.carSelected = "true";
            if (upcomingFilter === "quick_reservation") params.isQuickReservation = "true";
            break;
        case RESERVATION_TAB_KEYS.ONGOING:
            params.isApproved = "true";
            params.isCarPickedUp = "true";
            params.isCarDroppedOff = "false";
            break;
        case RESERVATION_TAB_KEYS.PAST:
            params.isCarPickedUp = "true";
            params.isCarDroppedOff = "true";
            endpoint = "/api/past-reservation/list";
            break;
        case RESERVATION_TAB_KEYS.REJECTED:
            params.isRejected = "true";
            endpoint = "/api/past-reservation/list";
            break;
        case RESERVATION_TAB_KEYS.CANCELLED:
            params.isCancelled = "true";
            endpoint = "/api/past-reservation/list";
            break;
        default:
            break;
    }

    return { endpoint, params };
};

const fetchTabPage = async ({ tabKey, page, pageSize, upcomingFilter }) => {
    const { endpoint, params } = getTabRequest(tabKey, upcomingFilter);
    const queryParams = new URLSearchParams({ limit: String(pageSize), page: String(page), ...params });
    const res = await apiClient.get(`${endpoint}?${queryParams}`);

    if (res?.data?.success) {
        return {
            rows: res?.data?.data?.result || [],
            total: res?.data?.data?.meta?.total || 0,
        };
    }

    return { rows: [], total: 0 };
};

/**
 * Every reservation for a tab, so the list can be searched across fields in the browser.
 * The list endpoints can't do that themselves (exact-match only on /api/reservation/list).
 */
const fetchAllReservationsForTab = async ({ tabKey, upcomingFilter = "all" }) => {
    if (tabKey === RESERVATION_TAB_KEYS.ALL) {
        return fetchAllReservationsCombined();
    }
    const { rows } = await fetchTabPage({ tabKey, page: 1, pageSize: FETCH_ALL_LIMIT, upcomingFilter });
    return rows;
};

export default fetchAllReservationsForTab;
